import React from 'react';
import BaseSelect from '../../FormField/Select';
import withStyles from '@material-ui/core/styles/withStyles';

const Select = withStyles((theme) => ({
  root: {
    [theme.breakpoints.up('sm')]: {
      minWidth: 150,
    },
  },
}))(({ classes, choices, initialValue, labelId, label, onChange }) => (
  <BaseSelect
    choices={choices}
    includeBlank
    blankText="-"
    fullWidth
    className={classes.root}
    value={initialValue}
    labelId={labelId}
    label={label}
    onChange={onChange}
    MenuItemProps={{ dense: true }}
  />
));

export default Select;
